import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'warehouse';

const warehouseService = {
  getRows: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/rows`,
      data,
    });
  },

  updateWarehouse: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createWarehouse: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteWarehouse: (data, code) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(code)}`,
      data,
    });
  },
  deleteWarehouse: (data, code) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(code)}`,
      data,
    });
  },
};
export default warehouseService;
